// import React from 'react';

// import { SEO } from 'main/components';

// export const BrincDronesSimulator = () => (
//   <>
//     <SEO seoTitle="ORQA - Brinc Drones Simulator" />
//     <section className="page">
//       <iframe
//         src="https://docs.google.com/forms/d/e/1FAIpQLSfKMun-N3_awR26wqNQAw1u74pvt60siTc_izymxf4TQP5fMg/viewform"
//         title="Fill out the form to get your license key for the simulator."
//         width="100%"
//         height="1500px"
//         frameBorder="0"
//       />
//     </section>
//   </>
// );

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

export const BrincDronesSimulator = () => {
  const history = useHistory();
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(prevCounter => prevCounter - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (counter === 0) {
      history.replace('/');
    }
  }, [counter, history]);

  return (
    <>
      <section
        className="page"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '50vh',
        }}
      >
        <div
          className="wrapper wrapper--narrow"
          style={{ textAlign: 'center' }}
        >
          <h1 className="t-beta s-bottom--sml">Redirecting to Homepage</h1>
          <p className="t-zeta s-bottom--sml" style={{ marginBottom: '1rem' }}>
            This page is obsolete and is no longer part of our active website.
            You will be automatically redirected to the Homepage in...
          </p>
          <div
            style={{
              fontSize: '4rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              minWidth: '60px',
            }}
          >
            {counter}
          </div>
          <p className="t-zeta">
            If you are not redirected, please click{' '}
            <a href="/">Homepage link</a>.
          </p>
        </div>
      </section>
    </>
  );
};
